var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDataTourGroups(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.19,
    height: 149.952,
    viewBox: "0 0 150.19 149.952",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4559",
    "data-name": "Group 4559",
    transform: "translate(-1073 -479.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4380",
    "data-name": "Group 4380",
    transform: "translate(1129.053 542.362)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4376",
    "data-name": "Group 4376",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4375",
    "data-name": "Group 4375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4374",
    "data-name": "Group 4374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4373",
    "data-name": "Group 4373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4372",
    "data-name": "Group 4372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4371",
    "data-name": "Group 4371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5856",
    "data-name": "Path 5856",
    d: "M29.4,42.515a6.549,6.549,0,0,0,5.556,3.156,6.494,6.494,0,0,0,6.268-4.8,5.181,5.181,0,0,0,.222-1.689A2.348,2.348,0,0,0,41.4,38.6a6.442,6.442,0,0,0-4.89-5.734,8.747,8.747,0,0,0-1.556-.222,4.067,4.067,0,0,0-.711.044.757.757,0,0,0-.311.044,6.589,6.589,0,0,0-5.512,6.445A6.769,6.769,0,0,0,29.4,42.515Zm-2.4.133a8.439,8.439,0,0,1-.756-3.512A8.8,8.8,0,0,1,32.47,30.78a4.162,4.162,0,0,0,.711-.178,10.9,10.9,0,0,0-3.023-3.289,6.847,6.847,0,0,0-1.734-.978,5.622,5.622,0,0,0-2-.445,4.936,4.936,0,0,0-1.734.311,6.858,6.858,0,0,0-1.778.933c-2.756,1.822-5.29,5.779-5.29,11.2a2.9,2.9,0,0,0,.267,1.289,3.1,3.1,0,0,0,.756,1.067,5.85,5.85,0,0,0,1.467.889A17.156,17.156,0,0,0,27,42.649Zm18.18-6.89a4.934,4.934,0,0,1-1.511,3.556.044.044,0,0,1-.044.044,8.684,8.684,0,0,1-8.668,8.4,8.591,8.591,0,0,1-6.49-2.934c-4.267.4-9.112-.4-11.29-2.534a7.726,7.726,0,0,1-.578-.667c-2.8-.178-5.467-.933-6.89-2.311A4.909,4.909,0,0,1,8.2,35.759a16.372,16.372,0,0,1,2.623-8.668,11.159,11.159,0,0,1,2.756-2.978,1.133,1.133,0,0,0,.267-.578,1.323,1.323,0,0,0-.267-.978A6.165,6.165,0,0,1,18.113,12.2a5.955,5.955,0,0,1,4.045,1.556,6.67,6.67,0,0,1,4.267-1.511,6.912,6.912,0,0,1,4.49,1.689A6.088,6.088,0,0,1,35.182,12.2a6.165,6.165,0,0,1,4.534,10.357,1.635,1.635,0,0,0-.267.978.882.882,0,0,0,.267.578,11.159,11.159,0,0,1,2.756,2.978A15.83,15.83,0,0,1,45.183,35.759Zm-2.045.622a2.734,2.734,0,0,0,.044-.578c.044-6.979-4.623-11.246-7.912-11.246a6.506,6.506,0,0,0-3.378,1.2,11.6,11.6,0,0,1,2.667,2.978,7.3,7.3,0,0,1,.978,1.734A8.7,8.7,0,0,1,43.138,36.381Zm-4.49-15.558a4.2,4.2,0,0,0,.756-2.445,4.25,4.25,0,0,0-4.223-4.223A4.158,4.158,0,0,0,32.2,15.4a6.859,6.859,0,0,1,1.067,3.645,7.954,7.954,0,0,1-.533,2.711,4.065,4.065,0,0,0,2.489.8,4.123,4.123,0,0,0,3.023-1.289A4.007,4.007,0,0,0,38.649,20.823ZM31,18.912a4.623,4.623,0,1,0-4.623,4.623A4.619,4.619,0,0,0,31,18.912Zm-11.335.178a6.76,6.76,0,0,1,1.2-3.867A4.064,4.064,0,0,0,18.113,14.2a4.25,4.25,0,0,0-4.223,4.223,3.936,3.936,0,0,0,.8,2.445,3.87,3.87,0,0,1,.4.489,4.123,4.123,0,0,0,3.023,1.289,3.714,3.714,0,0,0,2.178-.667A6.38,6.38,0,0,1,19.668,19.09Zm-1.245,9.646a11.617,11.617,0,0,1,2.889-3.156,5.713,5.713,0,0,0-3.156-1.067c-3.289,0-7.957,4.267-7.957,11.2a2.742,2.742,0,0,0,.933,2.178,8.759,8.759,0,0,0,4.534,1.556,5.265,5.265,0,0,1-.089-1.2A16.9,16.9,0,0,1,18.424,28.736Z",
    transform: "translate(-8.2 -12.2)",
    fill: "#dde4eb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379",
    transform: "translate(22.719 23.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4378",
    "data-name": "Group 4378",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4377",
    "data-name": "Group 4377"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5857",
    "data-name": "Path 5857",
    d: "M62.329,72.629l-2.005-1.912a.92.92,0,0,1-.233-1.119,1.057,1.057,0,0,1,1.679-.373c.42.373.793.746,1.212,1.166,1.166-1.306,2.331-2.565,3.451-3.87a1.06,1.06,0,0,1,1.725.28,1,1,0,0,1-.187,1.119c-.979,1.119-1.958,2.238-2.984,3.311l-1.166,1.306a.961.961,0,0,1-.793.326A.812.812,0,0,1,62.329,72.629Z",
    transform: "translate(-59.996 -66.189)",
    fill: "#dde4eb"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5142",
    "data-name": "Path 5142",
    d: "M111.093,131.424V35.732L90.113,14.75H29.535L23.161,28.733,28.937,41.4,23.161,54.067l5.776,12.666L23.161,79.4l5.776,12.675-5.776,12.671,5.776,12.68-6.374,14h88.53ZM90.883,19.243,106.6,34.96H90.883Zm-64.83,85.507L31.829,92.08,26.053,79.405l5.776-12.671L26.053,54.068,31.829,41.4,26.053,28.735l5.176-11.352H88.253v20.21h20.21v91.2H26.651l5.176-11.364Z",
    transform: "translate(1080.716 480.895)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5143",
    "data-name": "Path 5143",
    d: "M33.854,90.184a3.934,3.934,0,1,0-3.934,3.934A3.939,3.939,0,0,0,33.854,90.184Zm-6.992,0a3.056,3.056,0,1,1,3.056,3.056A3.061,3.061,0,0,1,26.862,90.184Z",
    transform: "translate(1083.3 534.841)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5144",
    "data-name": "Path 5144",
    d: "M10.932,27.812,9.193,31.335,5.305,31.9l2.814,2.742-.665,3.872,3.477-1.828,3.477,1.828-.663-3.872L16.56,31.9l-3.89-.565ZM12.8,34.335l.44,2.576L10.932,35.7,8.619,36.911l.44-2.576-1.87-1.825,2.586-.375,1.156-2.342,1.156,2.342,2.586.375Z",
    transform: "translate(1067.695 490.75)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    d: "M27.561,14.207l2.4-1.261,2.4,1.261L31.9,11.535l1.942-1.893-2.684-.391-1.2-2.432-1.2,2.432-2.684.391,1.942,1.893Zm.4-3.955,1.383-.2L29.963,8.8l.618,1.251,1.383.2-1,.976L31.2,12.6l-1.235-.649-1.235.649.235-1.376Z",
    transform: "translate(1083.368 474.911)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5146",
    "data-name": "Path 5146",
    d: "M84.873,69.281l1.942,1.893-.458,2.672,2.4-1.261,2.4,1.261L90.7,71.174l1.942-1.893-2.684-.391-1.2-2.432-1.2,2.432Zm3.884-.84.618,1.251,1.383.2-1,.975.235,1.376-1.235-.649-1.235.649.235-1.376-1-.975,1.383-.2Z",
    transform: "translate(1127.729 519.908)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5147",
    "data-name": "Path 5147",
    d: "M89.97,14.135l-1.583,4.872H83.266l4.142,3.012-1.583,4.87L89.97,23.88l4.144,3.011-1.583-4.87,4.142-3.012H91.552Zm1.53,7.55.946,2.909L89.97,22.8l-2.476,1.8.946-2.909-2.476-1.8h3.062l.946-2.911.946,2.911h3.062Z",
    transform: "translate(1126.517 480.431)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5148",
    "data-name": "Path 5148",
    d: "M80.823,13.134A3.934,3.934,0,1,0,76.889,9.2,3.939,3.939,0,0,0,80.823,13.134Zm0-6.99A3.056,3.056,0,1,1,77.766,9.2,3.061,3.061,0,0,1,80.823,6.144Z",
    transform: "translate(1121.705 473.74)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5149",
    "data-name": "Path 5149",
    d: "M86.837,50.334A3.134,3.134,0,1,0,89.971,47.2,3.137,3.137,0,0,0,86.837,50.334Zm3.134-2.256a2.256,2.256,0,1,1-2.256,2.256A2.259,2.259,0,0,1,89.971,48.077Z",
    transform: "translate(1129.211 505.378)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5150",
    "data-name": "Path 5150",
    d: "M16.739,23.079A4.142,4.142,0,1,0,12.6,18.936,4.147,4.147,0,0,0,16.739,23.079Zm0-7.407a3.265,3.265,0,1,1-3.265,3.265A3.269,3.269,0,0,1,16.739,15.671Z",
    transform: "translate(1073.197 480.928)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5151",
    "data-name": "Path 5151",
    d: "M23.889,88.411c-.57-.114-1.133-.242-1.691-.381l-.214.849c.572.146,1.149.274,1.733.391Z",
    transform: "translate(1080.28 536.184)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5152",
    "data-name": "Path 5152",
    d: "M10.281,79l-.751.449c.595.995,1.247,1.972,1.937,2.9l.705-.521C11.5,80.92,10.863,79.967,10.281,79Z",
    transform: "translate(1070.883 529.369)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5153",
    "data-name": "Path 5153",
    d: "M21.762,88.025c-1.065-.381-2.123-.821-3.146-1.305l-.375.793c1.047.5,2.133.947,3.225,1.339Z",
    transform: "translate(1077.456 535.196)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5154",
    "data-name": "Path 5154",
    d: "M18.185,86.619c-.967-.581-1.918-1.219-2.828-1.9l-.525.7c.933.695,1.909,1.349,2.9,1.944Z",
    transform: "translate(1074.883 533.689)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5155",
    "data-name": "Path 5155",
    d: "M14.948,84.525c-.839-.763-1.647-1.574-2.4-2.412l-.651.588c.774.86,1.6,1.691,2.463,2.474Z",
    transform: "translate(1072.666 531.72)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5156",
    "data-name": "Path 5156",
    d: "M6.864,71.871c.178,1.2.418,2.4.711,3.574l.889-.224c-.288-1.146-.522-2.319-.695-3.484Z",
    transform: "translate(1068.994 522.402)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5157",
    "data-name": "Path 5157",
    d: "M6.646,69.692q0,.9.044,1.8l.915-.044q-.041-.872-.042-1.752,0-.9.044-1.805l-.915-.044C6.661,68.461,6.646,69.078,6.646,69.692Z",
    transform: "translate(1068.812 519.159)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5158",
    "data-name": "Path 5158",
    d: "M9.96,78.638c-.486-1.026-.925-2.084-1.3-3.144l-.826.3c.39,1.086.84,2.17,1.337,3.223Z",
    transform: "translate(1069.6 526.726)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5159",
    "data-name": "Path 5159",
    d: "M6.87,66.68l.905.134q.132-.891.312-1.783l-.9-.18C7.066,65.461,6.96,66.07,6.87,66.68Z",
    transform: "translate(1068.999 516.667)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5160",
    "data-name": "Path 5160",
    d: "M90.156,76.019,89.279,76q-.018.868-.1,1.721l.874.081C90.11,77.213,90.143,76.62,90.156,76.019Z",
    transform: "translate(1130.98 527.109)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5161",
    "data-name": "Path 5161",
    d: "M78.524,89.448l.182.858a24.528,24.528,0,0,0,3.739-1.116l-.318-.818A23.357,23.357,0,0,1,78.524,89.448Z",
    transform: "translate(1122.939 536.443)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5162",
    "data-name": "Path 5162",
    d: "M86.474,86.6a25.057,25.057,0,0,0,2.355-3.111l-.739-.474a24.067,24.067,0,0,1-2.272,3Z",
    transform: "translate(1128.442 532.404)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5163",
    "data-name": "Path 5163",
    d: "M85.6,86.217a23.977,23.977,0,0,1-3.088,2.149l.442.758a24.7,24.7,0,0,0,3.2-2.228Z",
    transform: "translate(1125.947 534.817)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5164",
    "data-name": "Path 5164",
    d: "M88.121,82.659l.805.349a24.5,24.5,0,0,0,1.265-3.691l-.849-.218A23.609,23.609,0,0,1,88.121,82.659Z",
    transform: "translate(1130.18 529.446)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5165",
    "data-name": "Path 5165",
    d: "M77.185,90.141l-.044-.876c-.57.03-1.142.042-1.725.026l-.018.877q.253.005.505.005C76.332,90.174,76.76,90.163,77.185,90.141Z",
    transform: "translate(1120.581 537.116)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2468",
    "data-name": "Rectangle 2468",
    width: 0.877,
    height: 3.509,
    transform: "translate(1218.743 519.553)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2469",
    "data-name": "Rectangle 2469",
    width: 0.877,
    height: 3.509,
    transform: "translate(1218.743 526.571)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2470",
    "data-name": "Rectangle 2470",
    width: 0.877,
    height: 3.509,
    transform: "translate(1218.743 533.589)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2471",
    "data-name": "Rectangle 2471",
    width: 0.877,
    height: 3.509,
    transform: "translate(1218.743 540.607)",
    fill: "#dde4eb"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataTourGroups);
export default __webpack_public_path__ + "static/media/no-data-tour-groups.82ab7636.svg";
export { ForwardRef as ReactComponent };